export enum SmsSenderType {
  MESSAGING_SERVICE = 'MessagingService',
}

export type SmsSender = {
  id: number;
  projectId: number;
  phoneNumber: string;
  espAccountId: number;
  name: string;
  type: string;
  messageTypeId?: number;
};

export enum SMS_SENDER_FORM_FIELD_NAMES {
  PHONE_NUMBER = 'phoneNumber',
  ESP_ACCOUNT_ID = 'espAccountId',
  NAME = 'name',
  TYPE = 'type',
  MESSAGE_TYPE_ID = 'messageTypeId',
}

export type SmsSenderMutationActionResult = {
  failure: null | { message: string }[];
  success: null | { name: string };
};
